import React, { useCallback, useState, useEffect } from 'react';
import { Redirect, useHistory, useRouteMatch, useLocation, Route } from 'react-router-dom';
import { Layout, message } from 'antd';

import LevelUpHeader2 from 'src/components/Header/LevelUpHeader2';
import Navigation from 'src/components/Navigation';
import Loading from 'src/components/common/Loading';

import { useQueryProxy } from 'src/operations/proxy/user';
import { USER_ME } from 'src/operations/queries/getUser';
import { isLogedIn, userInfoVar } from 'src/apollo/cache';
import { getCurrentToken } from '../utils';
import { storage } from 'src/utils/hooks';
import { useAuthCheck } from 'src/utils/hooks';
import { useApolloClient, useQuery } from '@apollo/client';
import jwtDecode from 'jwt-decode';
import { useSelector } from 'react-redux';
import { classStoreData } from 'src/operations/store';
import { isMobileOnly } from 'react-device-detect';
const { Content } = Layout;

function useQueryParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function LevelUpLayout3({
  component: Component,
  logOut,
  isHeaderStatic = false,
  closeHeader = false,
  hideMenu = false,
  removeMargin = false,
  ...rest
}) {
  const companyName = useSelector(classStoreData);
  const history = useHistory();
  const queryParams = useQueryParams();
  const token = getCurrentToken();
  const client = useApolloClient();
  const [loaded, setLoaded] = useState(false);
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const shouldHideHeaderOnMobileLevelUp = isMobileOnly && pathname.startsWith('/level-up');
  const isLevelUpAssignPage = pathname.includes('/booklist/assign');

  const { loading, data, refetch } = useQueryProxy(USER_ME, {
    variables: { token },
    skip: !token,
    notifyOnNetworkStatusChange: false,
    onError(error) {
      isLogedIn(false);
      if (history.location.pathname !== '/login') {
        history.replace('/login');
      }
      setLoaded(true);
    },
  });
  useEffect(() => {
    if (!isLogedIn() || !token) {
      if (history.location.pathname !== '/login') {
        history.replace('/login');
      }
    }
  }, [history, token]);

  useEffect(() => {
    if (data?.me) {
      userInfoVar(data?.me);
      setLoaded(true);
    } else if (token) userInfoVar(jwtDecode(token));
  }, [data, loading, token]);

  useEffect(() => {
    const checkSessionOnFocus = () => {
      const currentToken = getCurrentToken();

      if (!currentToken) {
        isLogedIn(false);
        if (history.location.pathname !== '/login') {
          history.replace('/login');
        }
        return;
      }

      refetch({ token: currentToken }).catch(() => {
        // The query's onError handler redirects to login.
      });
    };

    window.addEventListener('focus', checkSessionOnFocus);
    return () => window.removeEventListener('focus', checkSessionOnFocus);
  }, [history, refetch]);

  const onCollapse = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const matchTest = useRouteMatch(['/test/new/:id/:type']);
  useEffect(() => {
    //placement test 용으로 로그인했을 경우, 시험보는 페이지가 아니면 로그아웃 처리한다.
    if (!matchTest && data?.me?.level_test === 1) {
      isLogedIn(false);
      userInfoVar(null);
      client.clearStore();
      client.cache.gc();
      storage.removeItem('culp_token');
      //history.replace('/level-test');
      //return <Redirect to={`/level-test`} />;
    }
  }, [data, matchTest, client]);

  const { isAccepted } = useAuthCheck();

  if (!token || !isLogedIn()) {
    return <Redirect to="/login" />;
  }

  if (isAccepted === false) {
    return <Redirect path="/" />;
  }
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <>
          {!loaded ? (
            <Loading />
          ) : (
            <Layout
              className={isLevelUpAssignPage ? 'level-up-assign-layout' : 'level-up-layout level-up-layout2'}
              style={isLevelUpAssignPage ? { background: '#e9f5f8', minHeight: '100vh', overflowX: 'hidden' } : undefined}
            >
              {collapsed && <Navigation />}

              <Layout
                className="main-layout"
                style={isLevelUpAssignPage ? { background: '#e9f5f8', height: '100vh', minHeight: '100vh', overflowX: 'hidden' } : undefined}
              >
                {!queryParams.get('removeHeader') && !shouldHideHeaderOnMobileLevelUp ? (
                  <LevelUpHeader2
                    collapsed={collapsed}
                    onCollapse={onCollapse}
                    isStatic={isHeaderStatic}
                    closeHeader={closeHeader}
                    hideMenu={hideMenu}
                  />
                ) : null}
                <Content
                  style={
                    removeMargin || isLevelUpAssignPage
                      ? {
                          background: '#e9f5f8',
                          height: isLevelUpAssignPage ? 'calc(100vh - 64px)' : undefined,
                          overflowY: isLevelUpAssignPage ? 'auto' : undefined,
                          overflowX: isLevelUpAssignPage ? 'hidden' : undefined,
                        }
                      : { margin: '0 16px' }
                  }
                >
                  <Component {...matchProps} {...rest} />
                </Content>
              </Layout>
            </Layout>
          )}
        </>
      )}
    />
  );
}

export default LevelUpLayout3;
